import { CoreButton } from '@components'
import AnnounceIcon from '@images/icons/announce-icon.svg?react'
import ArrowIcon from '@images/icons/arrow-down-icon.svg?react'
import { useOnboardingAction } from '@onboarding/hooks'
import { useMerchantQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'

import './CoreOnboardingAnnounce.scss'

export const CoreOnboardingAnnounce = ({ alternative }: { alternative?: 'CASH_TO_CODE' | null }) => {
  const { merchant, isMerchantProspect } = useMerchantQry()
  // const { onboardingStatus } = merchant || {}

  const { onboardingAction, startOrContinueOnboarding, getOnboardingStatusText } = useOnboardingAction()

  const announceConstants = {
    CASH_TO_CODE: {
      title: tr('FRONTEND.ANNOUNCE.CASHTOCODE.TITLE', 'Please Note'),
      text: tr(
        'FRONTEND.ANNOUNCE.CASHTOCODE.TEXT',
        'CashtoCode payment method supports only predefined amount. \nPlease select amount that is close to the one you want to deposit in your account.'
      ),
      buttonText: '',
      enableButton: false
    }
  }

  return (
    <>
      {isMerchantProspect && merchant?.onboardingStatus !== 'APPROVED' ? (
        <div className='core-onboarding-announce'>
          <div className='core-onboarding-announce-title-wrapper'>
            <div className='core-onboarding-header-left-side'>
              <div className='core-onboarding-announce-icon'>
                <AnnounceIcon />
              </div>
              <p>{getOnboardingStatusText()}</p>
            </div>
            {onboardingAction !== 'UNDER_REVIEW' && merchant?.onboardingStatus !== 'REJECTED_FINAL' && (
              <CoreButton
                size='normal'
                text={tr(`FRONTEND.BANKING.ONBOARDING.BUTTON.VERIFY`, 'Verify')}
                fitContent
                RightIcon={<ArrowIcon />}
                variation='primary-black'
                className='core-onboarding-announce-button'
                onClick={startOrContinueOnboarding}
              />
            )}
          </div>
        </div>
      ) : (
        alternative && (
          // alternative path (if onboarding is done)
          <div className='core-onboarding-announce'>
            <div className='core-onboarding-announce-title-wrapper'>
              <div className='core-onboarding-header-left-side'>
                <div className='core-onboarding-announce-icon'>
                  <AnnounceIcon />
                </div>
                <p>{announceConstants[alternative].title}</p>
              </div>
              {announceConstants[alternative].enableButton && (
                <CoreButton
                  size='normal'
                  text={announceConstants[alternative].buttonText}
                  fitContent
                  RightIcon={<ArrowIcon />}
                  className='core-onboarding-announce-button'
                  onClick={() => startOrContinueOnboarding()}
                />
              )}
            </div>
            <div className='core-onboarding-announce-content-wrapper'>{announceConstants[alternative].text}</div>
          </div>
        )
      )}
    </>
  )
}
